import axios from 'axios'
import { API_KEY, API_URL, CUSTOMERS_KEY } from '../keys'
import CategoriesEntity from '@/entities/api/categories/categories'

export const createCategory = async (
	token: string,
	data: Partial<CategoriesEntity>
) => {
	const response = await axios.post(`${API_URL}/categories`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const updateCategoryById = async (
	token: string,
	id: string,
	data: Partial<CategoriesEntity>
) => {
	const response = await axios.patch(`${API_URL}/categories/${id}`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const fetchCategories = async (token: string) => {
	const response = await axios.get(`${API_URL}/categories`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const removeCategoryById = async (token: string, id: string) => {
	const response = await axios.delete(`${API_URL}/categories/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
